<template>
  <div :style="{ zoom: zoomRatio }">
    <div v-if="chartsNum <= 3" class="firstRow">
      <pump-one-day-graph v-for="(one, i) in rows1" :key="`one_graph_less3_${i}`" style="display:inline-block" :is-first="i === 0" :is-last="i === rows1.length - 1" :value="one" :warnings="warnings" :basal-rate-info-msg="basalRateInfoMsg" :yesterday="helperGetYesterdayOtherData(one, i)" :all-deadline-gaps="allDeadlineGaps"
                          :setting="setting" :no-meal-highlight="noMealHighlight" :no-horizontal-split-line="noHorizontalSplitLine"
                          :upload-events="uploadEvents" :basal-rate-base-setting="basalRateBaseSetting" :quickPumpTagList="quickPumpTagList" />
      <slot name="chartBar">
      </slot>
    </div>
    <div v-else class="firstRow">
      <pump-one-day-graph v-for="(one, i) in rows1" :key="`one_graph_larger4_${i}`" style="display:inline-block" :is-first="i === 0" :is-last="i === rows1.length - 1" :value="one" :warnings="warnings" :basal-rate-info-msg="basalRateInfoMsg" :yesterday="helperGetYesterdayOtherData(one, i)" :all-deadline-gaps="allDeadlineGaps"
                          :setting="setting" :no-meal-highlight="noMealHighlight" :no-horizontal-split-line="noHorizontalSplitLine" 
                          :upload-events="uploadEvents" :basal-rate-base-setting="basalRateBaseSetting" :quickPumpTagList="quickPumpTagList" />
    </div>
    <div v-if="chartsNum <= 3" class="secondRow">
    </div>
    <div v-else class="secondRow">
      <pump-one-day-graph v-for="(one, i) in rows2" :key="`one_graph_r2_${i}`" style="display:inline-block" :is-first="i === 0" :is-last="i === rows2.length - 1" :value="one" :warnings="warnings" :basal-rate-info-msg="basalRateInfoMsg" :yesterday="helperGetYesterdayOtherData(one, i)" :all-deadline-gaps="allDeadlineGaps"
                          :setting="setting" :no-meal-highlight="noMealHighlight" :no-horizontal-split-line="noHorizontalSplitLine"
                          :upload-events="uploadEvents" :basal-rate-base-setting="basalRateBaseSetting" :quickPumpTagList="quickPumpTagList" />
      <slot name="chartBar">
      </slot>
    </div>
    <div class="legend chartMultiDailyPumpLegend">
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="circle-highcolor--filled" />
        </template>
        {{$t('High BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="circle-normalcolor--filled" />
        </template>
        {{$t('Normal BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="circle-lowcolor--filled" />
        </template>
        {{$t('Low BG')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-basalrate" />
        </template>
        {{$t('Basal Rate')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-bolus" />
        </template>
        {{$t('Bolus')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-extendedbolus" />
        </template>
        {{$t('Extended Bolus')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-dual" />
        </template>
        {{$t('Dual Bolus')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="zebra-3" />
        </template>
        {{$t('Temporary Basal Rate')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-stopline" />
        </template>
        {{$t('Stop Line')}}
      </wt-legend>      
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-alarm3" />
        </template>
        {{$t('Alarm')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-clock" />
        </template>
        {{$t('Time Change')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-needle" />
        </template>
        {{$t('Quick Bolus')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-upload2" />
        </template>
        {{$t('Upload')}}
      </wt-legend>
      <wt-legend>
        <template slot="icon">
          <svg-icon icon-class="pumpicon-resovior3" />
        </template>
        {{$t('Reservoir')}}
      </wt-legend>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import PumpOneDayGraph from './pumpOneDayGraph'
import wtLegend from '@c/Legend'
import { qcopy } from '@u'

export default {
  name: 'CChartMultiDailyPump',
  mixins: [reDrawTrigger],
  props: {
    quickPumpTagList: { // 立即大剂量(用户通过泵体的快捷键打的大剂量)
      type: [Array],
      default: () => []
    },
    basalRateBaseSetting: {
      type: [Array],
      default: () => []
    },
    uploadEvents: { // 上传数据事件
      type: [Array],
      default: () => []
    },
    allDeadlineGaps: {
      type: [Array],
      default: () => []
    },
    noMealHighlight: {
      type: [Boolean],
      default: false
    },
    noHorizontalSplitLine: {
      type: [Boolean],
      default: false
    },
    setting: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    basalRateInfoMsg: {
      type: [Array],
      default: () => []
    },
    warnings: {
      type: [Array],
      default: () => []
    },
    values: {
      type: [Array],
      default: () => []
    }
  },
  computed: {
    rows1() {
      const { chartsNum, values = [] } = this
      const tmp = values.slice()
      if (chartsNum <= 3) {
        return tmp
      } else {
        tmp.splice(4)
        return tmp
      }
    },
    rows2() {
      const { chartsNum, values = [] } = this
      if (chartsNum <= 3) {
        return []
      } else {
        const tmp = values.slice()
        const rest = tmp.splice(4)
        return rest
      }
    },
    chartsNum() {
      const { values = [] } = this
      return values.length
    }
  },
  components: {
    PumpOneDayGraph,
    wtLegend
  },
  methods: {
    helperGetYesterdayOtherData(one) {
      const { yesterday = {}} = one
      // console.error(`one: ${one.date} , yesterday `, yesterday)
      return one.yesterday
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables';
$pl: $sizePaddingTopLegend;

.legend.chartMultiDailyPumpLegend {
    margin-left: $pl * 2;
    margin-top: 12px;
    &.legend--row2 {
        margin-top: $pl;
        margin-bottom: $pl + 4px;
    }
    ::v-deep > .wtLegend-ctn {
        zoom: calc(22 / 22);
        margin-left: $pl;
        &:first-child {
            margin-left: 0;
        }
    }
}
.secondRow > * {
    margin-top: 24px;
    vertical-align: top;
    &.bar-ctn:last-child {
        margin-top: 76px;
        margin-left: 76px;
    }
}
.firstRow > * {
    vertical-align: top;
    &.bar-ctn:last-child {
        margin-top: 76px;
        margin-left: 76px;
    }   
}
</style>
